import React from 'react';
import PropTypes from 'prop-types';
import { pascalize } from 'humps';
import { useStateValue } from '../../shared/state';
import SubmissionFields from '../SubmissionFields';
import SubmissionFieldsProSessionSummary from '../SubmissionFields/ProSessionSummary';
import styles from './styles';

// Specific + Generic Submission Views
const SUBMISSION_VIEWS = {
  ProSessionSummary: SubmissionFieldsProSessionSummary,
  ProSessionSummaryNeedsFramework: SubmissionFieldsProSessionSummary,
  default: SubmissionFields,
};

const renderSubmissionView = () => {
  const [
    {
      submission: { id, name },
      questions,
      hidden,
      data,
      context,
      isReadOnly,
      features,
    },
  ] = useStateValue();

  return (context.forceDefaultView
    ? SUBMISSION_VIEWS.default
    : SUBMISSION_VIEWS[pascalize(name)] || SUBMISSION_VIEWS.default)({
    id,
    name,
    questions,
    hidden,
    data,
    context,
    features,
    isReadOnly,
  });
};

export default function Submission() {
  return <div className={styles.container}>{renderSubmissionView()}</div>;
}
